import React, { Component } from 'react';
import { connect } from 'react-redux';

import PopulationLegend from '../Shared/PopulationLegend';
import DistrictsLegend from '../Shared/DistrictsLegend';
import { general } from '../../data';

const imgs = general.imgs;

const mapStateToProps = state => {
  return {
    num_squares: state.slides.activeSlide.num_squares,
    yourDistricts: state.slides.activeSlide.yourDistricts
  };
}

class Result extends Component {
  render() {
    let image;
    const results = [];

    const counts = Object.keys(this.props.yourDistricts)
      .map(district => {

        const a = this.props.yourDistricts[district].a;
        const b = this.props.yourDistricts[district].b;

        if(a > b)   return 'a';
        if(a < b)   return 'b';
        if(a === b) return 'even';
        if(a === 4 || a === 5) return 'a';
        if(b === 4 || b === 5) return 'b';
      }).reduce((prev, next) => {
        if(next in prev) {
          prev[next]++
        } else {
          prev[next] = 1;
        }
        return prev;
      }, {});

    if(counts.even === 3 || (counts.even === counts.a && counts.even === counts.b)){
      image = imgs.scale_equal;
    }

    if(counts.a > counts.b){
      image = imgs.scale_purple;
    }

    if(counts.a < counts.b){
      image = imgs.scale_yellow;
    }

    let icon;
    if(this.props.type === 'results-success') {
      icon = imgs.success_icon;
    } else {
      icon = imgs.error_icon;
    }


    return (
      <div className="gm-slide__challenge">
        <PopulationLegend a={ this.props.population[0] } b={ this.props.population[1] } />
        <DistrictsLegend { ...this.props.yourDistricts } num_squares={ this.props.num_squares }/>
        <img className="gm-slide__image" src={image} />
        <img className="gm-slide__icon" src={icon} />
        <p className="gm-slide__results-text">{this.props.result_text}</p>
        <p className="gm-slide__description gm-slide__description--results">{this.props.text}</p>
      </div>
    );
  }
}

export default connect(mapStateToProps)(Result);



// WEBPACK FOOTER //
// ./src/components/Slides/Result.js